var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium" },
      [
        _c("Heading", { attrs: { title: _vm.$t("distribution") } }),
        _c("div", { staticClass: "default-content" }, [
          _c("p", { staticClass: "heading-small" }, [
            _vm._v(" " + _vm._s(_vm.$t("distribution_header")) + " "),
          ]),
          _c(
            "table",
            { staticClass: "table table-bordered table-responsive-md" },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("distribution_nr_crt")) + " "),
                  ]),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("distribution_work_point"))),
                  ]),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("label_county"))),
                  ]),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("label_locality"))),
                  ]),
                ]),
              ]),
              _vm._m(0),
            ]
          ),
          _c("p", { staticClass: "main-text" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("distribution_terminals_and_portals")) + " "
            ),
          ]),
          _c("table", { staticClass: "table table-bordered" }, [
            _c("thead", [
              _c("tr", [
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.$t("distribution_nr_crt"))),
                ]),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.$t("distribution_name"))),
                ]),
                _c("th", { attrs: { scope: "col" } }, [
                  _vm._v(_vm._s(_vm.$t("label_locality"))),
                ]),
              ]),
            ]),
            _c("tbody", [
              _c("tr", [
                _c("th", { attrs: { scope: "row" } }, [_vm._v("1")]),
                _c("td", [_vm._v(_vm._s(_vm.$t("distribution_terminals")))]),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.$t("distribution_location_terminal_details")) +
                      ": "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { target: "_blank", href: "https://selfpay.ro/" },
                    },
                    [_vm._v("www.zebrapay.ro")]
                  ),
                ]),
              ]),
              _c("tr", [
                _c("th", { attrs: { scope: "row" } }, [_vm._v("2")]),
                _c("td", [_vm._v(_vm._s(_vm.$t("distribution_untrr_portal")))]),
                _c("td", [_vm._v("www.e-rovinieta.ro")]),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tbody", [
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("1")]),
        _c("td", [_vm._v(" ARAD"), _c("br"), _vm._v(" 0720-999.231 ")]),
        _c("td", [_vm._v("ARAD")]),
        _c("td", [_vm._v("ARAD, STR. PRUNULUI NR. 66")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("2")]),
        _c("td", [_vm._v(" LIPOVA"), _c("br"), _vm._v(" 0720-999.231 ")]),
        _c("td", [_vm._v("ARAD")]),
        _c("td", [_vm._v("LIPOVA, STR. SLT. SUCIU SORIN NR. 134F")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("3")]),
        _c("td", [
          _vm._v(" PITEȘTI"),
          _c("br"),
          _vm._v(" 0720-999.230"),
          _c("br"),
          _vm._v(" 0720-999.209 "),
        ]),
        _c("td", [_vm._v("ARGEȘ")]),
        _c("td", [
          _vm._v(
            "PITEȘTI, CARTIER POPA ȘAPCĂ, STR. SF. VINERI, BL. P16, SC. B, AP. 2, PARTER"
          ),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("4")]),
        _c("td", [_vm._v(" ORADEA"), _c("br"), _vm._v(" 0720-999.259 ")]),
        _c("td", [_vm._v("BIHOR")]),
        _c("td", [_vm._v("ORADEA, SOS. BORȘULUI NR. 53")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("5")]),
        _c("td", [_vm._v(" BUCUREȘTI"), _c("br"), _vm._v(" 0720-999.253 ")]),
        _c("td", [_vm._v("BUCUREȘTI")]),
        _c("td", [
          _vm._v("BUCUREȘTI, STR. IENĂCHIȚĂ VĂCĂRESCU NR. 60, SECT. 4"),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("6")]),
        _c("td", [_vm._v(" CLUJ"), _c("br"), _vm._v(" 0720-999.250 ")]),
        _c("td", [_vm._v("CLUJ")]),
        _c("td", [_vm._v("CLUJ NAPOCA, STR. TRAIAN NR. 48")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("7")]),
        _c("td", [_vm._v(" DEVA"), _c("br"), _vm._v(" 0720-999.205 ")]),
        _c("td", [_vm._v("HUNEDOARA")]),
        _c("td", [
          _vm._v(
            "DEVA, B-DUL NICOLAE BĂLCESCU, NR. 24B, AP. 1A, COMPLEX VILLA PARK"
          ),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("8")]),
        _c("td", [
          _vm._v(" REDIU"),
          _c("br"),
          _vm._v(" 0720-999.242"),
          _c("br"),
          _vm._v(" 0720-999.228 "),
        ]),
        _c("td", [_vm._v("IAȘI")]),
        _c("td", [_vm._v("REDIU, BLOC DIANA, TRONSON 2, DEMISOL")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("9")]),
        _c("td", [_vm._v(" TÂRGU MUREȘ"), _c("br"), _vm._v(" 0720-999.244 ")]),
        _c("td", [_vm._v("MUREȘ")]),
        _c("td", [_vm._v("TÂRGU MUREȘ, STR. CĂLĂRAȘILOR NR. 82")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("10")]),
        _c("td", [_vm._v(" SATU MARE"), _c("br"), _vm._v(" 0720-999.247 ")]),
        _c("td", [_vm._v("SATU MARE")]),
        _c("td", [_vm._v("SATU MARE, STR. MARTIRILOR DEPORTAȚI NR. 10")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("11")]),
        _c("td", [_vm._v(" SIBIU"), _c("br"), _vm._v(" 0720-999.246 ")]),
        _c("td", [_vm._v("SIBIU")]),
        _c("td", [_vm._v("SIBIU, STR. COJOCARILOR, NR. 2")]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("12")]),
        _c("td", [_vm._v(" SUCEAVA"), _c("br"), _vm._v(" 0720-999.248 ")]),
        _c("td", [_vm._v("SUCEAVA")]),
        _c("td", [
          _vm._v("SUCEAVA, STR. ȘTEFAN CEL MARE NR. 47, BL. A1, SC. A, AP. 2"),
        ]),
      ]),
      _c("tr", [
        _c("th", { attrs: { scope: "row" } }, [_vm._v("13")]),
        _c("td", [_vm._v(" TIMIȘOARA"), _c("br"), _vm._v(" 0720-999.207 ")]),
        _c("td", [_vm._v("TIMIȘ")]),
        _c("td", [_vm._v("TIMIȘOARA, B-DUL TAKE IONESCU NR. 51")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }